export interface VerklaringPrintOptions {
  title: string;
  introText: string;
  declarationText: string;
  contactTitle: string;
  contactName: string;
  contactAddress: string;
  contactPhone: string;
  contactEmail: string;
  animalsLabel: string;
  animals: string;
  signatureLabel: string;
  signatureDataUrl: string | null;
  dateLabel: string;
  date: string;
  placeLabel: string;
  place: string;
  costs?: { label: string; total: string };
}

function esc(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function row(label: string, value: string): string {
  return value ? `<div class="row"><span class="lbl">${esc(label)}</span><span>${esc(value)}</span></div>` : "";
}

/**
 * "Print verklaring" — opens a clean, self-contained print window with the signed declaration
 * (finder's / surrender) and calls print(). Client-side (matches the React-rendered declaration);
 * the Jmix server-side OpenHTMLtoPDF template is not ported.
 */
export function printVerklaring(o: VerklaringPrintOptions): void {
  const win = window.open("", "_blank", "width=800,height=900");
  if (!win) return;
  const sig = o.signatureDataUrl
    ? `<img class="sig" src="${o.signatureDataUrl}" alt="" />`
    : `<div class="sig sig--empty"></div>`;
  const costs = o.costs ? `<div class="row"><span class="lbl">${esc(o.costs.label)}</span><span>${esc(o.costs.total)}</span></div>` : "";
  win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${esc(o.title)}</title>
<style>
  body { font: 13px/1.5 -apple-system, Segoe UI, Roboto, sans-serif; color: #111827; margin: 32px; }
  h1 { font-size: 18px; margin: 0 0 12px; }
  h2 { font-size: 13px; text-transform: uppercase; letter-spacing: .03em; color: #6b7280; margin: 18px 0 6px; }
  .row { display: flex; gap: 12px; padding: 2px 0; }
  .lbl { min-width: 9rem; color: #6b7280; }
  .decl { white-space: pre-line; border: 1px solid #e3e6ea; border-radius: 8px; padding: 12px; background: #f9fafb; }
  .sig { display: block; max-width: 320px; max-height: 130px; border: 1px solid #c3c8cf; border-radius: 6px; margin-top: 4px; }
  .sig--empty { width: 320px; height: 110px; }
  .sign-row { display: flex; gap: 48px; margin-top: 16px; }
  @media print { body { margin: 0; } }
</style></head><body>
  <h1>${esc(o.title)}</h1>
  <h2>${esc(o.contactTitle)}</h2>
  ${row("", o.contactName)}
  ${row("", o.contactAddress)}
  ${row("", o.contactPhone)}
  ${row("", o.contactEmail)}
  ${row(o.animalsLabel, o.animals)}
  <h2>${esc(o.title)}</h2>
  <p>${esc(o.introText)}</p>
  <div class="decl">${esc(o.declarationText)}</div>
  ${costs}
  <div class="sign-row">
    <div><h2>${esc(o.signatureLabel)}</h2>${sig}</div>
    <div>${row(o.dateLabel, o.date)}${row(o.placeLabel, o.place)}</div>
  </div>
  <script>window.onload = function(){ window.focus(); window.print(); };</script>
</body></html>`);
  win.document.close();
}
